/* eslint-disable prettier/prettier */
export type EnvConfig = {
  NEXT_PUBLIC_GTAG_ID: string | undefined;
  NEXT_PUBLIC_APP_VERSION: string | undefined;
  CHAIN_WHITELIST: string | undefined;
  NEXT_PUBLIC_WC_PROJECT_ID: string | undefined;
};

let values: EnvConfig = {
  NEXT_PUBLIC_GTAG_ID: undefined,
  NEXT_PUBLIC_APP_VERSION: undefined,
  CHAIN_WHITELIST: undefined,
  NEXT_PUBLIC_WC_PROJECT_ID: undefined,
};

export function initializeEnv(newValues: EnvConfig): void {
  values = newValues;
}

export const getEnv = (): EnvConfig => values;
